import React, { ReactNode, useState } from 'react';

interface Initial {
  errors?: ErrorStates;
  setErrors: (error?: ErrorStates) => void;
  clearError: () => void;
}

interface ErrorStates {
  meals?: string;
  unknown?: string;
}

interface Props {
  children: ReactNode | ReactNode[];
}

export const ErrorContext = React.createContext<Initial>({} as Initial);

export const ErrorProvider: React.FC<Props> = ({ children }) => {
  const [errors, setErrors] = useState<ErrorStates | undefined>(undefined);

  const onError = (error?: ErrorStates): void => {
    if (error && (error.meals || error.unknown)) {
      setErrors(error);
    } else {
      setErrors({ unknown: 'Oops! Something went wrong. Please try again later.' });
    }
  };

  const clearError = (): void => setErrors(undefined);

  return <ErrorContext.Provider value={{ errors, setErrors: onError, clearError }}>{children}</ErrorContext.Provider>;
};
